// extracted by mini-css-extract-plugin
export default {"lpus":"lpu_lpus__ZcXoP","lpu":"lpu_lpu__QcvRE"};